import { FormControl, FormGroup } from '@angular/forms';

export const CONSTS = {
  HEADER: $localize`Handover Scan Report`,
  DATE_LABEL: $localize`Date`,
  REFERENCE_NUM: $localize`Reference Number`,
};

export const REPORT_FILE_NAME = $localize`Handover Scan Report`;

type HandoverScanReportField = {
  date: FormControl<Date>;
  refNums: FormControl<string>;
};

export type HandoverScanReportFormGroup =
  FormGroup<HandoverScanReportField> | null;
